import ReactGA4 from 'react-ga4'

/**
 * This function is used to track when a navigation bar link is clicked while the user is on home page
 * @param destination - The destination of the navigation bar link
 */
export const trackNavigationWhileOnHomePage = (destination: string) => {
  ReactGA4.event({
    category: 'Navigation',
    action: 'Navigation bar clicked while on home page',
    label: destination,
  })
}
